import { createAction } from '@reduxjs/toolkit';
import { AppDispatch } from 'src/redux/store';

export const setCurrentConflictTab = createAction<string>('setConflictTab');

export const setConflictTab = (id: string) => (dispatch: AppDispatch) => {
    dispatch(setCurrentConflictTab(id));
};
